import { PricingPlan } from './types';

// Remove free and pro plans - enterprise only
export const ENTERPRISE_PLAN: PricingPlan = {
  id: 'enterprise',
  name: 'Enterprise Plan',
  priceString: 'Contact for pricing',
  price: 0, // Price will be custom/contact-based
  period: 'month',
  analysisLimit: 100000, // 100 licenses × 1000 analyses = 100,000 total
  features: [
    '100 user licenses included',
    '1,000 analyses per license per month',
    'Advanced AI matching & insights',
    'Custom interview plans & assessments',
    'Technical skill evaluation',
    'Market intelligence & benchmarking',
    'Priority enterprise support',
    'Advanced analytics dashboard',
    'Job description generator',
    'Bulk analysis capabilities',
    'API access & integrations',
    'Custom training & onboarding',
    'Dedicated account manager',
    'SLA guarantees',
    'Advanced security & compliance'
  ],
  mainFeatures: [
    '100 licenses × 1,000 analyses each',
    'Complete enterprise feature set',
    'Market intelligence included',
    'Priority support & SLA',
    'Custom integrations available',
    'Dedicated account management'
  ],
  isEnterprisePlan: true,
  maxLicenses: 100,
  analysesPerLicense: 1000
};

export const PRICING_PLANS = {
  ENTERPRISE: ENTERPRISE_PLAN
} as const;